import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class CompanyService extends GenericService {
  constructor() {
    super('/companies', axiosInstance);
  }
}

export default new CompanyService(); 